import { components } from "./apex-client-gen";

export type TransactionInfo = {
  kind: "deposit" | "withdraw";
  amount: number;
  plaidAccountId: string;
  custodianAccountId: string;
  iraContributionType?:
    | "TYPE_UNSPECIFIED"
    | "REGULAR"
    | "EMPLOYEE"
    | "EMPLOYER"
    | "RECHARACTERIZATION"
    | "ROLLOVER_60_DAY"
    | "ROLLOVER_DIRECT"
    | "TRANSFER"
    | "TRUSTEE_FEE"
    | "CONVERSION"
    | "REPAYMENT";

  iraContributionYear?: number;
  iraDistributionType?:
    | "TYPE_UNSPECIFIED"
    | "NORMAL"
    | "DISABILITY"
    | "SOSEPP"
    | "PREMATURE"
    | "DEATH"
    | "EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE"
    | "EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE"
    | "ROLLOVER_TO_QUALIFIED_PLAN"
    | "ROLLOVER_TO_IRA"
    | "DISTRIBUTION_TRANSFER"
    | "RECHARACTERIZATION_PRIOR_YEAR"
    | "RECHARACTERIZATION_CURRENT_YEAR"
    | "DISTRIBUTION_CONVERSION"
    | "MANAGEMENT_FEE"
    | "PLAN_LOAN_401K"
    | "PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS"
    | "NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS";
  iraDistributionFederalWithhold?: number;
  iraDistributionStateWithhold?: number;
  iraDistributionStateWithholdWaiver?: boolean;
};

export type GetBankRelationshipResponse =
  components["schemas"]["GetMyBankRelationshipsResponse"];

export type GetBankRelationshipResponseEntry =
  GetBankRelationshipResponse["bank_relationships"];

export type MakeDepositsResponse =
  components["schemas"]["MakeDepositsResponse"];
export type MakeDepositsRequest =
  components["schemas"]["CreateDepositRequest-Input"];

export type MakeWithdrawalsResponse =
  components["schemas"]["MakeWithdrawalsResponse"];
export type MakeWithdrawalsRequest =
  components["schemas"]["CreateWithdrawalRequest-Input"];

export const IRA_ACCOUNT_TYPES = new Set([
  "RETIREMENT_TRADITIONAL",
  "RETIREMENT_ROTH",
  "RETIREMENT_ROLLOVER",
]);
